import { Link } from 'react-router';
import { Logo } from '@/components/brand/Logo';

const footerLinks = [
  { to: '/pricing', label: 'Pricing' },
  { to: '/roadmap', label: 'Roadmap' },
  { to: '/changelog', label: 'Changelog' },
  { to: '/compare/vendoo', label: 'Compare' },
  { to: '/about', label: 'About' },
  { to: '/help', label: 'Help' },
  { to: '/legal/terms', label: 'Terms of Service' },
  { to: '/legal/privacy', label: 'Privacy Policy' },
  { to: '/legal/security', label: 'Security' },
];

export function PublicFooter() {
  return (
    <footer className="border-t border-fos-border">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 px-4 py-8 text-sm text-fos-text-muted sm:flex-row">
        <div className="flex items-center gap-2">
          <Logo variant="wordmark" size="sm" scheme="light" />
          <span>· AI-native reseller OS</span>
        </div>
        <nav className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
          {footerLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="transition-colors hover:text-fos-text-primary"
            >
              {link.label}
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  );
}
